export const eng = {
    global: {
        test: "test",
        next: "Next",
        name: "Name",
        email: "Email",
        view: "View",
        edit: "Edit",
        close: "Close",
        DOWNLOAD: "DOWNLOAD",
        submit: "Submit",
        ADD: "ADD",
        CANCEL: "CANCEL",
        SAVE: "SAVE",
        DELETE: "DELETE",
        SHARE: "SHARE",
        no: "No",
        type: "Type",
        english: "English",
        thai: "Thai",
        emailEtc: "name@example.com",
        ark_for_help: "Ask for help",
        Search: "Search",
    },
    category: {
        power_skill: {
            empathy: "Empathy",
            self_awareness: "Self-awareness",
            leadership: "Leadership",
            initiative_making: "Initiative-making",
            optimism: "Optimism",
            critical_thinking: "Critical Thinking",
        },
        frequency: {
            one_time: "One-time",
            weekly: "Weekly",
            monthly: "Monthly",
            quarterly: "Quarterly",
            biannually: "Biannually",
            yearly: "Yearly",
        },
        day_of_week: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
        },
        day_of_week_m: {
            mon: "Mon",
            tue: "Tue",
            wed: "Wed",
            thu: "Thu",
            fri: "Fri",
            sat: "Sat",
            sun: "Sun",
        },
        Talent_Types: {
            Starter:"Starter",
            Marginalized: "Marginalized",
            Latent_Potential: "Latent Potential",
            Up_and_coming: "Up-and-coming",
            Supported: "Supported",
            Underutilized: "Underutilized",
            Contributor: "Contributor",
            Rising_Star: "Rising Star",
            High_Contributor: "High Contributor",
            Activated: "Activated",
            Crowd_Favorite: "Crowd Favorite",
            Developing: "Developing",
            Community_Pillar: "Community Pillar",
            Key_Player: "Key Player",
            Respected_Expert: "Respected Expert",
            Distinguished_Talent: "Distinguished Talent",
            Engaged_Contributor: "Engaged Contributor",
            Valued_Contributor: "Valued Contributor",
            Untapped_Potential: "Untapped Potential",
            Emerging_Talent: "Emerging Talent",
            Core_Player: "Core Player",
            High_Performer: "High Performer",
            Hidden_Talent: "Hidden Talent",
            Unsung_Talent: "Unsung Talent",
            High_Potential: "High Potential",
            Solid_Performer: "Solid Performer",
            Superstar: "Superstar",
        },
        Network_type: {
            Low_Network: "Low Network",
            Medium_Inner: "Medium Inner",
            High_Inner: "High Inner",
            Super_Inner: "Super Inner",
            Medium_Outer: "Medium Outer",
            High_Outer: "High Outer",
            Super_Outer: "Super Outer",
            Medium_Network: "Medium Network",
            High_Network: "High Network",
            Super_Network: "Super Network",
        }
    },
    page: {
        awards: "Awards",
        awardsDescription: "Get recognized as a top employer with behavior-driven metrics",
        status: "Status",
        timeLine: "Timeline",
        billing: "Billing",
        billing_description: "Charges made to your account for subscriptions and rewards",
        happilyVillage: "Happily Village",
        happilyVillage_description: "View and manage village interactions and experiences",
        overview: "Overview",
        university: "University",
        townHall: "Town Hall",
        runningTrack: "Running Track",
        battleStadium: "Battle Stadium",
        insights: "Insights",
        insights_description: "Real-time data and insights into your teams and people",
        skills: "Skills",
        skills_description: "Identifying strengths and opportunities for learning and development",
        dashboard: "Dashboard",
        teams: "Teams",
        cohorts: "Cohorts",
        managers: "Managers",
        people: "People",
        reportCard: "Report Card",
        integrations: "Integrations",
        integrations_description: "Sync employee data and connect with other services",
        dashboard: "Dashboard",
        HRIS_Sync: "HRIS Sync",
        API: "API",
        members: "Members",
        members_description: "Manage your members, teams, and managers",
        teams: "Teams",
        managers: "Managers",
        API: "API",
        power_up: "Power-ups",
        power_up_description: "Send recognition to awesome people",
        recognition: "Recognition",
        recognition_description: "Send recognition to awesome people",
        performance: "Performance",
        performance_description: "Track performance towards culture and goals and understand focus areas",
        focus_areas: "Focus Areas",
        goals: "Goals",
        coming_soon: "Coming soon...",
        create: "Create",
        outbox: "Outbox",
        activity: "Activity",
        questions: "Questions",
        questions_description: "Manage questions, add your own, and view responses",
        standard: "Standard Library",
        custom: "Custom Questions",
        reports: "Reports",
        reports_description: "Preview and download auto-generated reports",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        rewards: "Rewards",
        rewards_description: "Manage your Gift Cards and Company Rewards",
        gift_cards: "Gift Cards",
        perks: "Perks",
        team_building: "Team Building",
        doing_good: "Doing Good",
        setup_wizard: "Setup Wizard",
        setup_wizard_description: "Let’s get you set up! You are minutes away from a happier workplace.",
        sparks: "Sparks",
        sparks_description: "Transform how your employees and managers approach problems",
        micro_learning: "Micro-Learning",
        leaderboards:"Leaderboards",
    },
    commponents: {
        years: "years",
        months: "months",
        days_ago: "days ago",
        joined_after: "joined after",
        joined: "Joined",
        daily_streak: "Daily Streak",
        achievements: "Achievements",
        super_feedback: "Super Feedback",
        MOST_RECENT: "MOST RECENT",
        power: "Power",
        badges: "Badges",
        org: "Org",
        relationships: "Relationships",
    },
    setupWizard: {
        stepOne: {
            title: "Welcome",
            hi: "Hi",
            header: "Welcome to Happily!",
            contentOne: "You’re awesome for initiating positive experiences in your workplace. With Happily, you’re enabling better feedback, recognition, learning, community and so much more!",
            contentTwo: "To get started, we need to get your team set up, select rewards, and send out invites. Let’s begin!",
            What_are_your: "What are your company’s core values?",
        },
        stepTwo: {
            title: "Create Team",
            header: "Create Your Team",
            contentOne: "Happily works in teams and managers are at the center. Feedback, Insights, and Reports are sent to team managers on each workday to help them better understand their team in real-time. Help us set up your team.",
            teamName: "Team Name",
            teamNameEtc: "ACME Inc",
            managersNameEt: "Manager’s Name",
            email: "Email",
            memberName: "Member Name",
        },
        stepThree: {
            title: "Select Rewards",
            contentOne: "Your team can use coins and gems collected from answering daily questions (and other interactions) to redeem rewards! Select your rewards below. You can add custom rewards later on as well.",
            SelectOneTitle: "Company Perks",
            SelectOneContentOne: "Start with our curated selection of workplace benefits that reward your most engaged employees.",
            SelectOneContentTwo: "Rewards can be configured from your admin console.",
            SelectTwoTitle: "Gift Cards (not available in the trial)",
            SelectTwoContentOne: "Let your team redeem Gift Cards from local vendors and online stores.",
            SelectTwoContentTwo: "Buy credits to enable gift cards, no extra charges applied.",
        },
        stepFour: {
            title: "Confirm & Invite",
            contentOne: "We’re almost done! Set a time you’d like your teams to receive their daily pulse questions. We recommend selecting the time when your team is commuting to work.",
            quickSettings: "QUICK SETTINGS",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "WHAT HAPPENS NEXT",
            contentOneWhatHappensNext: "Invitations will be sent out to your team and everyone will receive their first set of daily pulse questions on the next workday.",
            contentTwoWhatHappensNext: "Explore your admin console to add members, view insights, create custom questions & rewards, or edit your account settings.",
        },
    },
    fourZeroFour: {
        looks_like_somehing: "Looks like something went wrong",
        the_page_you: "the page you are looking for is not available!",
        home_page: "Home Page"
    },
    awards: {
        happily_awards: "Happily Awards",
        recognition_driven: "Recognition-driven",
        the_practice_of: "The practice of recognition drives positive reinforcement and is critical to motivating top talent and creating high-performing teams",
        past_thirty_day_participation: "Past 30 day participation",
        required: "Required",
        or_higher: "or higher",
        open_feedback: "Open Feedback",
        continuous_feedback_drives: "Continuous feedback drives continuous improvement and signals a high psychological safety work environment",
        past_thirty_day_open: "Past 30 day open feedback rate",
        active_managers: "Active Managers",
        people_managers_are: "People managers are in the best position to proactively help, engagement, and retain talent on their team",
        past_thirty_day_activity: "Past 30 day activity",
        strong_company_culture: "Strong Company Culture",
        culture_is_a_byproduct: "Culture is a byproduct of core values and behaviors. A strong culture allows you to execute strategy effectively and innovate",
        most_recent_culture: "Most recent Culture Index score",
        high_well_being: "High Well-being",
        employee_wellness_and: "Employee wellness and well-being deserves attention and care, and directly contributes to organizational resilience",
        most_recent_WHO_5: "Most recent WHO-5 Index score",
        happiest_workplace: "Happiest Workplace",
        a_happy_workplace: "A happy workplace is driven by positive habits — recognition, open feedback, active manages, strong culture, and high well-being",
        awards_collected: "Awards collected",
        collect_all_other: "Collect all other awards",
        share_your_award: "Share your award",
        share_your_award_with: "Share your award with others. Your award has been published and is ready to view at the web address below.",
        coppy: "Coppy",
        embed_code: "Embed code",
        preview_link_in: "Preview link in new tab",
        to_embed_this: "To embed this award on your website, simply copy and paste the code below into the HTML code on your website.",

        all_time: "All-Time",
        consistency: "Consistency",
        current_streak: "Current Streak",
        start_date: "Start Date",
        january_one: "January 1",
        today: "Today",
        highlighted_are_periods: "Highlighted are periods when recognition participation is",
        or_higher: "or higher",
        days: "days",
        required_collect_all: "Required: Collect all other awards",
    },
    billing: {
        BILLING_SUMMARY: "BILLING SUMMARY",
        SUBSCRIPTION: "SUBSCRIPTION",
        REWARDS_CHARGES: "REWARDS CHARGES",
        REWARD_CREDIT_BALANCE: "REWARD CREDIT BALANCE",
        REWARDS_PENDING: "REWARDS PENDING",
        active_members: "Active Members",
        credit_balance: "Credit Balance",
        credit_remaining: "Credit Remaining",
        Date: "Date",
        Category: "Category",
        Description: "Description",
        Amount: "Amount",
        Status: "Status",
        seats_charged: "seats charged",
    },
    happilyVillage: {
        Mission_Entries: "Mission Entries",
        Mission: "Mission",
        add_mission: "add mission",
        Order: "Order",
        Mission_Name_and: "Mission Name & Description",
        Entries: "Entries",
        Winner: "Winner",
        Status: "Status",
        Week: "Week",
        entries: "entries",
        Live: "Live",
        Completed: "Completed",
        Unskip_Mission: "Unskip Mission",
        Skip_Mission: "Skip Mission",
        Edit: "Edit",
        Delete: "Delete",
        Upcoming: "Upcoming",
        View_Details: "View Details",
        Preview_on_Mobile: "Preview on Mobile Layout",
        New_Mission: "New Mission",
        Exntry_XP: "Entry XP",
        PLAY: "PLAY",
        VOTE: "VOTE",
        Name_of_Mission: "Name of Mission",
        Please_input_Name: "Please input Name",
        Name_of_your_Mission: "Name of your Mission (e.g., Take the best group selfie)",
        Name_of_your_Mission_th: "Name of your Mission (Thai)",
        Description: "Description",
        A_sentence_or_two: "A sentence or two describing the mission details",
        Please_input_Description: "Please input Description",
        A_sentence_or_two_th: "A sentence or two describing the mission details (Thai)",
        Mission_Type: "Mission Type",
        Please_input_Mission_Type: "Please input Mission Type",
        Entry_Bonus_XP: "Entry Bonus (XP)",
        Please_input_Entry_Bonus: "Please input Entry Bonus",
        Please_input_Order: "Please input Order",
        Select: "Select",
        Please_input_Status: "Please input Status",
        CREATE_MISSION: "CREATE MISSION",
        SAVE_MISSION: "CREATE MISSION",
        HAPPILY_HOUSES: "HAPPILY HOUSES",
        THIS_WEEK: "THIS WEEK",
        This_Week: "This Week",
        This_Month: "This Month",
        Last_Week: "Last Week",
        Last_Month: "Last Month",
        All_time: "All-time",
        Level: "Level",
        total_members: "total members",
        House_XP: "House XP",
        XP: "XP",
        person: "person",
        Distance: "Distance",
        km: "km",
        km_per_person: "km / person",
        entries: "entries",
        participation: "participation",
        university: "university",
        A_count_of_how_many_learning: "A count of how many learning and activity interactions have been created from University sessions",
        Learning_and_Activity: "Learning & Activity Interactions",
        See_more: "See more",
        town_hall: "town hall",
        A_count_of_how_many_comments: "A count of how many comments and replies have been initiated through topic and polls in the Town Hall",
        Knowledge_Sharing_Interactions: "Knowledge Sharing Interactions",
        running_track: "running track",
        A_count_of_distance_traveled: "A count of distance traveled by walking and running on the Running Track, including the effect of Boosters",
        km_Distance_Traveled: "km Distance Traveled",
        BATTLE_STADIUM: "BATTLE STADIUM",
        A_count_of_how_many_entries: "A count of how many entries have been submitted towards weekly missions in the Battle Stadium",
        House_of: "House of",
        members: "members",
        making_up: "making up",
        of_Happily_Village: "of Happily Village",
        Distance_Traveled: "Distance Traveled",
        Running_Track_Leaderboard: "Running Track Leaderboard",
        Today: "Today",
        Rank: "Rank",
        Name: "Name",
        results_from: "results from",
        results: "results",
        This_week: "This week",
        No_Active_Boosters: "No Active Boosters",
        This_month: "This month",
        All_time: "All-time",
        Town_Hall_Topics: "Town Hall Topics, Polls, & Group Checklists",
        Create: "Create",
        New_Topic: "New Topic",
        New_Poll: "New Poll",
        New_Checklist: "New Checklist",
        Creator: "Creator",
        Type: "Type",
        View: "View",
        Views: "Views",
        Engagement: "Engagement",
        Date_and_Time: "Date and Time",
        Duplicate: "Duplicate",
        Edit: "Edit",
        Delete: "Delete",
        comment: "comment",
        comments: "comments",
        votes: "votes",
        By: "By",
        Topic_Creator: "Topic Creator",
        Share_with: "Share with",
        Huddle_selection_is: "Huddle selection is currently only available in the mobile app.",
        Coming_soon_to: "Coming soon to the My Happily console.",
        Team_or_Name: "Team or Name of Recipient",
        Title_of_Topic: "Title of Topic",
        Title_of_Poll: "Title of Poll",
        Short_but_descriptive: "Short but descriptive",
        A_sentence_or_two_poll: "A sentence or two about this poll",
        Share_with: "Share with",
        Item_label: "Item label",
        A_sentence_or_two: "A sentence or two about this topic",
        Comments_enabled: "Comments enabled",
        UPLOAD_MEDIA: "UPLOAD MEDIA",
        Save_Changes: "Save Changes",
        CREATE_TOPIC: "CREATE TOPIC",
        by: "by",
        Summary: "Summary",
        items: "items",
        You_are_completed: "You’ve completed",
        Weekly_reminders_to: "Weekly reminders to update your progress is on",
        Group_Checklist_Creator: "Group Checklist Creator",
        Select_Creator: "Select Creator",
        Title_of_Checklist: "Title of Checklist",
        Please_input_title: "Please input title",
        Checklist_Item: "Checklist Item",
        ADD_OPTION: "ADD OPTION",
        Show_respondents_in_results: "Show respondents in results",
        Weekly_Reminders_off: "Weekly Reminders off",
        Every_week_on: "Every week on",
        at: "at",
        if_checklist_is: "if checklist is incomplete, send a reminder notification",
        Save_Changes: "Save Changes",
        CREATE_CHECKLIST: "CREATE CHECKLIST",
        CREATE_POLL: "CREATE POLL",
        Poll_Creator: "Poll Creator",
        Poll_Title: "Poll Title",
        Option: "Option",
        Option_label: "Option label",
        Search: "Search",
        learning_and_activity_interactions: "learning & activity interactions",
        University_Sessions: "University Sessions",
        add_session: "add session",
        campaigns: "Campaigns",
        Create_Campaign: "Create Campaign",
        Campaign_Title: "Campaign Title",
        Icon: "Icon",
        Theme: "Theme",
        Input_Type: "Input Type",
        Timing: "Timing",
        Goal: "Goal",
        Reward: "Reward",
        Entry_Cost: "Entry Cost",
        Daily: "Daily",
        Weekly: "Weekly",
        Instant_Coins: "Instant Coins",
        Charged_Coins_On_Completion: "Charged Coins on Completion",
        Prize_Pool_Split_At_End: "Prize Pool (Split at End)",
        Individual_Goal: "Individual Goal",
        Group_Goal: "Group Goal",
        Start_Date: "Start Date",
        End_Date: "End Date",
        Participants: "Participants",
        All: "All",
        Sign_ups: "Sign ups",
        name: "name",
        Creator: "Creator",
        Topic: "Topic",
        Price: "Price",
        coins: "coins",
        Free: "Free",
        Delete: "Delete",
        Led_by: "Led by",
        SIGN_UPS: "SIGN UPS",
        spots_available: "spots available",
        PRICE: "PRICE",
        Share_with: "Share with",
        Huddle_selection_is: "Huddle selection is currently only available in the mobile app.",
        Coming_soon_to_the: "Coming soon to the My Happily console.",
        Name_of_Session: "Name of Session",
        Short_but_descriptive_eg: "Short but descriptive (eg. Excel Analysis 101)",
        Please_input_Name: "Please input Name",
        A_sentence_or_two_about: "A sentence or two about the session",
        Date_and_Time: "Date & Time",
        When: "When",
        Please_input_Date: "Please input Date & Time",
        Duration_minutes: "Duration (minutes)",
        How_long: "How long?",
        Please_input_Duration: "Please input Duration",
        Location: "Location",
        Please_input_Location: "Please input Location",
        Session_Limit: "Session Limit",
        Where: "Where",
        How_many: "How many?",
        Please_input_Session_Limit: "Please input Session Limit",
        Price_coins: "Price (coins)",
        Please_input_rice: "Please input Price",
        How_much: "How much?",
        Add_to_Topic: "Add to Topic",
        Comment_Permissions: "Comment Permissions",
        Save_Changes: "Save Changes",
        CREATE_SESSION: "CREATE SESSION",
        Created_by: "Created by",
        sign_ups_of: "sign ups of",
        available_spots: "available spots",
        No_one_sign_up: "No one sign up.",
        Participants: "Participants",
    },
    insights: {
        HAPPINESS_VS_RISK_RATE: "Happiness vs. Risk & Activity",
        Duration: "Duration",
        Last_30_days: "Last 30 days",
        Last_60_days: "Last 60 days",
        Last_13_weeks: "Last 13 weeks",
        Last_26_weeks: "Last 26 weeks",
        Last_52_weeks: "Last 52 weeks",
        Last_24_months: "Last 24 months",
        HAPPINESS: "HAPPINESS",
        RISK: "RISK",
        ACTIVE_USERS: "ACTIVE USERS",
        COHORT_STATUS: "Cohort Status",
        Sort_by: "Sort_by",
        Cohorts: "Cohorts",
        Satisfaction: "Satisfaction",
        Co_Alignment: "Co. Alignment",
        Score_Distribution: "Score Distribution",
        Engagement_and_Impact: "Engagement & Impact",
        Highlighting_key_engagement_metrics: "Highlighting key engagement metrics such as eNPS, NPS, Wellness, Culture, and Employee Resilience Index scores as well as an overview of individual impact and manager activity.",
        high_impact: "high impact",
        contributors: "contributors",
        People: "People",
        managers: "managers",
        non_active: "non-active",
        active: "active",
        Managers: "Managers",
        eNPS: "eNPS",
        Report_Card: "Report Card",
        Promoters: "Promoters",
        Passives: "Passives",
        Detractors: "Detractors",
        Excellent: "Excellent",
        Fair: "Fair",
        Critical: "Critical",
        Poor: "Poor",
        point_same_benchmark: "point same benchmark",
        points: "points",
        above_benchmark: "above benchmark",
        below_benchmark: "below benchmark",
        Happiness_Rate: "Happiness Rate",
        Risk_Rate: "Risk Rate",
        View_by_team: "View by team",
        Open_ended_Feedback: "Open-ended Feedback",
        How_would_you_like: "How would you like your",
        manager_to_be_more: "manager to be more involved?",
        Activity: "Activity",
        Adoption: "Adoption",
        Members: "Members",
        Monthly_Active_Users: "Monthly Active Users",
        Weekly_Active_Users: "Weekly Active Users",
        ACTIVITY_THIS_WEEK: "ACTIVITY THIS WEEK",
        WEEKLY_ACTIVE_USERS: "WEEKLY ACTIVE USERS",
        HAPPINESS_RATE: "HAPPINESS RATE",
        RISK_RATE: "RISK RATE",
        FEEDBACK_RESPONSE_RATE: "FEEDBACK RESPONSE RATE",
        By_Job_Tenure: "By Job Tenure",
        Engagement_Trend: "Engagement Trends",
        Engagement_Trend_Desc: "The change of engagement over a 3-month period as measured by the Dynamic Engagement Behavioral Index (DEBI) for your overall company, managers, and leaders.",
        A_breakdown_of_your: "A breakdown of your activity and rates by job tenure, the duration of time an employee has worked at your company",
        Real_time_Activity: "Real-time Activity",
        PAST_12_HOURS: "PAST 12-HOURS",
        BY_HOUR: "BY HOUR",
        TOP_ACTIVITIES: "TOP ACTIVITIES",
        TIMES: "TIMES",
        Key_Teams_and_Cohorts: "Key Teams & Cohorts",
        Highlighting_key_groups: "Highlighting key groups that exhibit high or low scores in happiness, risk, feedback rate, or activity",
        TONE_ANALYZER: "Tone Analyzer",
        BETA: "BETA",
        TALKING_POINTS: "Talking Points",
        show_timeline: "show timeline",
        Success_Score: "Success Score",
        Dimension: "Dimension",
        Status_no_teams: "Status (no. teams)",
        Positive: "Positive",
        Neutral: "Neutral",
        Critical: "Critical",
        Close: "Close",
        ENGAGEMENT_BREAKDOWN_BY_TEAM: "Engagement Breakdown by Team",
        Sort_by: "Sort by",
        Lowest_Success_Score: "Lowest Success Score",
        Highest_Success_Score: "Highest Success Score",
        DIMENSION_DETAILS: "Dimension Details",
        TALKING_POINTS: "Talking Points",
        Lowest_Happiness: "Lowest Happiness",
        Highest_Happiness: "Highest Happiness",
        Lowest_Risk: "Lowest Risk",
        Highest_Risk: "Highest Risk",
        
        ACTIVITY_OVERVIEW: "Activity Overview",
        Last_30_days: "Last 30 days",
        ACTIVE: "Responsive",
        PASSIVE: "Moderate",
        INACTIVE: "Minimal",
        DAILY_INSIGHTS_OPENED: "DAILY INSIGHTS OPENED",
        WEEKLY_INSIGHTS_OPENED: "WEEKLY INSIGHTS OPENED",
        FEEDBACK_REPLY_RATE: "FEEDBACK REPLY RATE",
        BY_MANAGER: "Manager Interactions",
        Managers_activity_in: "Managers activity in opening insights and replying to team feedback over the past 30-days",
        Insights_Open_Rate: "Insights Open Rate",
        Team_Size: "Team Size",
        Feedback_Reply_Rate: "Feedback Reply Rate",
        All_Activity_Types: "All Activity Types",
        Active: "Responsive",
        Passive: "Moderate",
        Inactive: "Minimal",
        Insights_Opened: "Insights Opened",
        Feedback: "Feedback",
        Relational: "Relational",
        Team_Challenges: "Team Challenges",
        Date: "Date",
        Score: "Score",
        Challenge: "Challenge",
        Status: "Status",
        Profile: "Profile",
        Daily: "Daily",
        Weekly: "Weekly",
        Reply: "Reply",
        Super: "Super",
        Talent_Type: "Talent Type",
        Excels_At: "Excels At",
        Network_Type: "Network Type",
        Critical_Areas: "Critical Areas",
        critical_area: "critical area",
        results_from: "results from",
        results: "results",
        Lower: "Lower",
        Upper: "Upper",
        Feedback_Reply_Rate: "Feedback Reply Rate",
        Insights_Open_Rate: "Insights Open Rate",
        Feedback_Reply_Rate: "Feedback Reply Rate",
        SAVE: "SAVE",
        CANCEL: "CANCEL",

        Select_all: "Select all",
        Clear: "Clear",
        Talent_Types_are_tagged: "Talent Types are tagged according to a low, rising, high, or super rating of their network effectiveness (individual's collaborative contribution to the organization) and individual rating (a evaluation of performance from their manager)",
        Cancel: "Cancel",
        Okay: "Okay",
        Power_Skills: "Power Skills",
        Network_Type: "Network Type",
        Talent_Type: "Talent Type",
        OUTER_NETWORK: "OUTER NETWORK",
        NETWORK_EFFECTIVENESS: "Network Effectiveness",
        PEOPLE_INTELLIGENCE: "People Intelligence",
        INDIVIDUAL_PERFORMANCE: "Individual Performance",
        INNER_NETWORK: "INNER NETWORK",
        Sort_By: "Sort By",
        Highest_Risk_Level: "Highest Risk Level",
        Lowest_Risk_Level: "Lowest Risk Level",
        Highest_Star_Count: "Highest Star Count",
        Lowest_Star_Count: "Lowest Star Count",
        Highest_Impact_Rating: "Highest Impact Rating",
        Lowest_Impact_Rating: "Lowest Impact Rating",
        Super_Network_Effectiveness : "⬆️ Super Network Effectiveness ",
        Rising_Network_Effectiveness: "⏫ Rising Network Effectiveness",
        High_Network_Effectiveness: "🔼 High Network Effectiveness",
        Low_Network_Effectiveness: "🔽 Low Network Effectiveness",
        Super_Individual_Rating: "⬆️ Super Individual Rating",
        Rising_Individual_Rating: "⏫ Rising Individual Rating",
        High_Individual_Rating: "🔼 High Individual Rating",
        Low_Individual_Rating: "🔽 Low Individual Rating",
        No_Description: "No Description",
        Problem_Areas: "Problem Areas",
        People_Impact_and: "People Impact & Risk Trends",
        RISK_LEVELS: "Risk Levels",
        AVG_IMPACT_RATING: "Avg Impact Rating",
        view_list: "view list",
        Excels_at: "Excels at",
        profiles: "profiles",
        were_tagged_by: "were tagged by their peers for this attribute",
        Name_Team_and: "Name, Team, and Happiness",
        Talent_Type: "Talent Type",
        Talent_is_classified: "Talent is classified by frequency and quality of recognition",
        coins_and_gems: "(coins and gems) received. Coins are a measure of",
        Network: "Network",
        Effectiveness: "Effectiveness",
        Gems_are_a_measure: "Gems are a measure of",
        Individual_Performance: "Individual Performance",
        Low: "Low",
        Low_frequency: "Low frequency",
        Uptake: "Uptake",
        A_recent_increase_in: "A recent increase in frequency",
        High: "High",
        High_frequency: "High frequency",
        Super: "Super",
        High_frequency_and_high: "High frequency and high quality",
        Read_more_here: "Read more here",
        Network_Type: "Network Type",
        Impact_Rating: "Impact Rating",
        Talent_Type: "Talent Type",
        Based_on_manager_and: "Based on manager and peer recognition in the past 6-months.",
        Network_Type: "Network Type",
        Based_on_connections_created: "Based on connections created through peer feedback, recognition, and gifting interactions in the past 6-months.",
        Engagement_Group: "Engagement Group",
        Based_on_the_quality_and: "Based on the quality and effort of key engagement behaviors last month.",
        Truly_Outstanding: "Truly Outstanding",
        Truly_Outstanding_ratings: "Truly Outstanding ratings from Peer Feedback received in the past 6-months.",
        Medals: "Medals",
        Medals_received_in_the: "Medals received in the past 6-months.",
        Star_Performer: "Star Performer",
        Number_of_weeks_qualified: "Number of weeks qualified as a Star Performer in the past 6-months.",
        Talent_is_classified_by: "Talent is classified by the number of inner and outer",
        connections_as_determined: "connections (as determined by the org structure) from",
        recognition_and_peer: "recognition and peer feedback data",
        Low_Network: "Low Network",
        Low_inner_and_outer: "Low inner and outer connections",
        High_Inner: "High Inner",
        High_Inner_but_low: "High inner but low outer connections",
        High_Outer: "High Outer",
        Low_inner_but_high: "Low inner but high outer connections",
        High_Network: "High Network",
        High_Network: "High inner and outer connections",
        Achievements: "Achievements",
        Impact_Rating: "Impact Rating",
        Risk_Level: "Risk Level",
        Talent_that_are_retention: "Talent that are retention risks detected from the frequency",
        of_Not_Great_and: "of “Not Great” and “Unhappy” responses related to “How are",
        you_feeling_today: "you feeling today?”",
        Low: "Low",
        Twice_last_week: "Twice last week",
        Medium: "Medium",
        More_than_twice: "More than twice last week",
        Medium: "Medium",
        High: "High",
        More_than_twice_last_and: "More than twice last week and the week before",
        profiles: "profiles",
        Highlighting_key_accomplishments: "Highlighting key accomplishments in engagement and recognition from peers and managers",
        Engagement_Group: "Engagement Group",
        Highly_Moderately_Somewhat_Under: "Highly, Engaged, Somewhat, Under Engaged, or In-active engagement groups are assigned based on behavioral metrics.",
        Medals: "Medals",
        Recognized_with_a_Leadership: "Recognized with a Leadership Medal of Excellence.",
        Truly_Outstanding: "Truly Outstanding",
        Recognized_as_Truly_Outstanding: "Recognized as Truly Outstanding from a Peer Feedback interaction.",
        Star_Performer: "Star Performer",
        A_star_is_earned: "A star is earned when qualifying as a Star Performer, finishing in the Top 15% of recognition receivers in any given week.",
        A_score_that_represents: "A score that represents an individual's impact on the organization and the people around them, determined by",

        TEAMS: "TEAMS",
        COHORTS: "COHORTS",
        REPORT_CARD_BY_TEAM: "Report Card by Team",
        REPORT_CARD_BY_COHORTS: "Report Card by Cohort",
        Highest_Scores: "Highest Scores",
        Lowest_Score: "Lowest Score",
        Scores_are_updated_on: "Scores are updated on a quarterly basis, and can be viewed in comparison with previous scores",
        SCORE_HISTORY: "SCORE HISTORY",
        Max_Change: "Max. Change",
        Most_Recent: "Most Recent",
        NPS: "NPS",
        eNPS: "eNPS",
        WHO_5: "WHO-5",
        eRes: "eRes",
        Culture: "Culture",
        DEBI: "DEBI",
        Index: "Index",
        Alignment: "Alignment",
        Variance: "Unity",
        Net_Promoter_Score_c_NPS: "Net Promoter Score ® (NPS)",
        Engagement_Score: "Engagement Score",
        Engagement_Score_is: "Dynamic Engagement Behavioral Index (DEBI) is a holistic approach to measuring employee engagement, moving beyond self-reported data to a more behaviorally anchored assessment.",
        Strategic_Alignment: "Strategic Alignment",
        Strategic_Alignment_is: "The Strategic Alignment Index measures how well teams understand and execute on priorities across four key dimensions: Understanding & Clarity, Execution & Confidence, Resource & Support, and Impact & Contribution. A higher score (0-100) indicates stronger alignment between daily work and organizational objectives. The Consistency Score reflects how uniformly this understanding is shared across team members, with higher scores indicating more consistent strategic alignment.",
        DEBI_report_card_label: "Dynamic Engagement Behavior Index measuring true engagement",
        Culture_Resilience_Well: "Culture, Resilience, Well-being Indexes",
        Net_Promotor_Score_is: "Net Promoter Score is a calculation based on promoters, passives, and detractors and range between -100 and +100.",
        Net_Promoter_Net_Promoter: "Net Promoter, Net Promoter System, Net Promoter Score, NPS and the NPS-related emoticons are registered trademarks of Bain & Company, Inc., Fred Reichheld and Satmetrix Systems, Inc.",
        A_collection_of_indexes: "A collection of indexes that provide a better understanding of your organizational culture, resilience, and well-being.",
        The_Culture_Index_is: "The Culture Index is based on measurements of behavior that indicate the strength of organizational culture.",
        The_Employee_Resilience_Index: "The Employee Resilience Index provides an indicator for the ability to bounce back from setbacks and respond to challenges.",
        The_WHO_5_Index_from: "The WHO-5 Index, from the World Health Organization, is a universal measurement for well-being.",
        Loyal_employees_who_are: "Loyal employees who are proud to work with you are your greatest assets in attracting better talent and helping overcome challenges during crisis.",
        Company_alignment_provides: "Company alignment provides managers and leaders with an understanding of how well their people are able to contribute to the company's objectives. Any mismatch is an under-utilization of resources that hinders growth, development, and engagement of the employees involved.",
        Feedback_has_significant: "Feedback has significant potential to benefit employees in terms of individual and team performance. Employees need a clear understanding of how they can improve. Continuous communication is critical",
        Recent_studies: "Recent studies",
        focus_on_how_mindset: "focus on how mindset plays a critical role in unleashing employee engagement.",
        Social_educational_and: "Social, educational, and organizational psychology illuminates how mindsets are a personal resource that may influence employees' engagement via their enthusiasm for development, construal of effort, focus of attention, perception of setbacks, and interpersonal interactions.",
        Managers_play_an_importan: "Managers play an important role in managing and shaping the mindset of their teams.",
        Employees_need_to_feel_that_they_are: "Employees need to feel that they are growing and learning at all times, both personally and professionally. Managers can play a role by being a coach and directing learning opportunities to their teams. And they also must make career development opportunities clear and transparent.",
        Employees_need_to_feel_taht_their_work: "Employees need to feel that their work is visible to others and that their effort gets the acknowledgment that it deserves. Recognition has been cited as 1 of 5 major activities that are shown to be a predictor of employee engagement.",
        The_support_that_employees: "The support that employees get from their coworkers is strongly linked to how well they are able to manage stress (wellness).",
        Studies: "Studies",
        show_that_satisfaction_with: "show that satisfaction with one's coworkers relates significantly to engagement.",
        The: "The",
        more_embedded_a_person: "more embedded a person",
        is_in_their_job: "is in their job, the less likely they are to leave it. If there are conflicts or issues among coworkers and team members, managers and leaders need to be able to act immediately.",
        Managers_set_standards_for: "Managers set standards for their team. And their direct reports want to impress them! For an effective relationship, managers should have a meaningful interaction with each direct report at least once every 2 weeks. Employees who have regular meetings with their managers are three times more likely to feel engaged in their company and thrive at their job.",
        Apart_from_pay_challenging: "Apart from pay, challenging work has been identified as the key motivator for employees. Employees need to feel that they're leading fulfilling careers and doing work that is the right fit of challenging, explained in Mihaly Csikszentmihalyi's theory of Flow - The Psychology of Optimal Experience.",
        Employees_need_work_life: "Employees need work-life balance to stay productive and engaged in their work. Studies have shown that workplace stress and burnout have a mediating effect on employee engagement. Both physical and mental wellness are considered.",
        Before: "Before",
        After: "After",
        Cancel: "Cancel",
        Compare: "Compare",
        There_is_no_happiness: "There is no happiness, risk, or activity data to display (yet). Please check back tomorrow!",

        SPOTLIGHT: "Spotlight",
        Most_Engaged: "Most Engaged",
        Teams_with_highest_engagement: "Teams with highest engagement scores. The score represents an aggregate score from 9-dimensions of engagement.",
        No_most_engaged_at: "No most engaged at this time",
        Retention_Risks: "Retention Risks",
        Teams_with_highest_retention: "Teams with highest retention risk scores. The score represents an aggregate from dimensions associated with attrition.",
        No_retention_risks_at: "No retention risks at this time",
        Teams_that_show_the_most: "Teams that show the most improvement over the past 2-weeks. The score represents the change increase of engagement scores.",
        No_most_improved_at: "No most improved at this time",
        Most_Critical: "Most Critical",
        Teams_that_are_most_critical: "Teams that are most critical over the past 2-weeks. The score represents the change decrease of engagement scores.",
        Most_Improved: "Most Improved",
        No_most_critical: "No most critical at this time",
        TEAM_STATUS: "Team Status",
        Team: "Team",
        Happi_Rate: "Happi. Rate",
        Risk_Rate: "Risk Rate",
        Feedback: "Feedback",
        Wellness: "Wellness",
        Rel_Manager: "Rel. Manager",
        Recognition: "Recognition",
        Ambassadorship: "Ambassadorship",
        Rel_Colleagues: "Rel. Colleagues",
        Personal_Growth: "Personal Growth",
        Co_Alignment: "Co. Alignment",
        Satisfaction: "Satisfaction",
        Strategic_Alignment_Details: "Strategic Alignment Details",
        Strategic_Alignment_Breakdown: "Strategic Alignment Breakdown",
        Strategic_Alignment_is: "The Strategic Alignment Index measures how well teams understand and execute on priorities across four key dimensions: Understanding & Clarity, Execution & Confidence, Resource & Support, and Impact & Contribution. A higher score (0-100) indicates stronger alignment between daily work and organizational objectives. The Consistency Score reflects how uniformly this understanding is shared across team members, with higher scores indicating more consistent strategic alignment.",
        Strongly_Agree: "Strongly Agree",
        Agree: "Agree",
        Neutral: "Neutral",
        Disagree: "Disagree",
        Strongly_Disagree: "Strongly Disagree",
        WHO_5_Breakdown: "WHO-5 Breakdown",
        WHO_5_Details: "WHO-5 Details",
        Culture_Index_Details: "Culture Index Details",
        Culture_Index_Breakdown: "Culture Index Breakdown",
        Scoped: "Scoped",
        Global: "Global",
        Current_Filtered_List: "Current Filtered List",
        Entire_Company: "Entire Company",
    },
    goals: {
        // Page
        team_goals: "Team Goals",
        goals_description: "Manage and track goals for each team",

        // Actions
        add_goals: "Add Goals",
        edit_goals: "Edit Goals",
        save: "Save",
        cancel: "Cancel",

        // Modal
        team_name: "Team",
        goals_label: "Team Goals",
        goals_placeholder: "Enter team goals and objectives, one per line...",
        goals_hint: "These goals will be used to provide targeted analysis and feedback guidance for managers and their teams.",
        add_goals_title: "Add Team Goals",
        edit_goals_title: "Edit Team Goals",

        // Empty States
        no_teams: "No teams found",
        no_goals: "No goals set",

        // Messages
        save_success: "Goals saved successfully",
        save_error: "Error saving goals. Please try again.",
    },
    integrations: {
        API_DOCUMENTATION: "API DOCUMENTATION",
        Reference_and_instructional: "Reference and instructional guides on available API actions",
        Go_to_API_Doc: "Go to API Doc",
        PRODUCTION_TOKEN: "PRODUCTION TOKEN",
        This_is_your_production: "This is your production token. Your API tokens need to be treated as securely as any other password.",
        Generate_a_Token: "Generate a Token",
        API_LOG: "API LOG",
        A_log_of_API_activity: "A log of API activity created by the API token associated with your account that details the date, API operation, status, and deployment type of the API transaction.",
        results_from: "results from",
        results: "results",

        SELECT_SYNC_METHOD: "SELECT SYNC METHOD",
        INTEGRATION_PARAMETERS: "INTEGRATION PARAMETERS",
        Webhook: "Webhook",
        Sort_by_Name: "Sort by Name",
        Token: "Token",
        Webhook_Endpoint: "Webhook Endpoint",
        Sync_Type: "Sync Type",
        Staged_Syncing: "Staged Syncing",
        Your_members_are_queued_up: "Your members are queued up and prepared for addition or deactivation. This method provides you with a chance to manually review changes before they're implemented",
        Normal_Syncing: "Normal Syncing",
        Users_can_be_added: "Users can be added to Happily directly, and will be automatically added or deactivated based on their status in your submitted data",
        Syncing: "Syncing",
        All_users_who_are: "All users who are in Happily, but not in the submitted data, will be deactivated",
        Options: "Options",
        Abbreviate_Team_Name: "Abbreviate Team Name",
        Automatically_abbreviate_long_team: "Automatically abbreviate long team names to make reports and insights more readable",
        Enable: "Enable",
        Enable_web_hook: "Enable web hook",
        Any_data_that: "Any data that you submit to the web hook will be synced with your network",
        Save_Changes: "Save Changes",
        WEBHOOK_LOGS: "WEBHOOK LOGS",
        Sync_users_using_your: "Sync users using your HRIS. This list contains the latest 50 HRIS Webhook requests. You can",
        Simulate_Changes: "Simulate Changes",
        to_see_how_the: "to see how the data would affect your network using your current HRIS Webhook sync settings",
        Date: "Date",
        Webhook_Content: "Webhook Content",
        Integration_Status: "Integration Status",
        Actions: "Actions",
        View_Changes: "View Changes",
        Simulate_Changes: "Simulate Changes",
        No_webhook_activity: "No webhook activity recorded",
        Members: "Members",

        INTEGRATION_STATUS: "INTEGRATION STATUS",
        HRIS_Sync: "HRIS Sync",
        Sync_your_employee_data: "Sync your employee data with your HRIS a single flow member management",
        Connected: "Connected",
        Setup: "Setup",
        Developer_API: "Developer API",
        Activate_your_developer: "Activate your developer program and get credentials to access API services",
        Connected: "Connected",
        SSO_Title: "Single Sign-On (SSO)",
        SSO_Desc: "Enable SSO as the authentication and provisioning method for member accounts",

        Directory_Sync: "Directory Sync",
        Endpoint: "Endpoint",
        Enable_Directory_Sync: "Enable Directory Sync",
        Directory_Sync_Desc: "Any data that submitted by your directory will be synced with your Happily account",
    },
    login: {
        sign_in_to: "Sign in to",
        please_enter_your: "Please enter your email address",
        keep_me_logged: "Keep me logged in",
        terms_and_Conditions: "Terms & Conditions",
        sign_in: "Sign in",
        your_account_access: "Your account access is blocked, outside valid access parameters",
        your_IP: "Your IP",
    },
    members: {
        ORGANIZATION_CHART_VIEW: "ORGANIZATION CHART VIEW",
        the_org_chart: "The org chart in its current view is too large to export as an image file.",
        
        Members: "Members",
        incomplete_profiles: "incomplete profiles",
        Archived: "Archived",
        ADD_MEMBER: "ADD MEMBER",
        EXPORT_ALL: "EXPORT ALL",
        REVIEW_UPDATES: "REVIEW UPDATES",
        members_selected: "members selected",
        RE_ASSIGN_MANAGER: "RE-ASSIGN MANAGER",
        EDIT_TEAM: "EDIT TEAM",
        ADD: "ADD",
        EDIT: "EDIT",
        ARCHIVE: "ARCHIVE",
        SEND_INVITE: "SEND INVITE",
        RE_ASSIGN: "RE-ASSIGN",
        IGNORE: "IGNORE",
        Invited: "Invited",
        Active: "Active",
        Inactive: "Inactive",
        All: "All",
        New: "New",
        Team: "Team",
        Member: "Member",
        Assign_Team: "Assign Team",
        Assign_Manager: "Assign Manager",
        Coins: "Coins",
        Gems: "Gems",
        Permission: "Permission",
        Status: "Status",
        results_from: "results from",
        results: "results",
        coins: "coins",
        gems: "gems",
        years: "years",
        months: "months",
        days_ago: "days ago",
        joined_after: "joined after",
        Joined: "Joined",
        Daily_Streak: "Daily Streak",
        Achievements: "Achievements",
        Super_Feedback: "Super Feedback",
        Problem_Areas: "Problem Areas",
        MOST_RECENT: "MOST RECENT",
        Powers: "Powers",
        Badges: "Badges",
        Knowledge: "Knowledge",
        Initiative: "Initiative",
        Contributor: "Contributor",
        Leadership: "Leadership",
        Health: "Health",
        Org: "Org",
        Relationships: "Relationships",
        Are_you_sure_would: "Are you sure would like to Archive this member?",
        Once_archived_the_member: "Once archived, the member will be automatically logged out of Happily and will not be able to login again.",
        Archived_members_can_be: "Archived members can be restored at a later time.",
        CANCEL: "CANCEL",
        First_Name: "First Name",
        Last_Name: "Last Name",
        Email: "Email",
        Manager: "Manager",
        Select_a_Manager: "Select a Manager",
        Select_a_Team: "Select a Team",
        Team: "Team",
        will_be_created_as_a: "will be created as a new team",
        User_role: "User role",
        emoji_Member: "👩🏻 Member",
        Limited_Access: "Limited Access",
        emoji_Admin: "✍🏻  Admin",
        integrations: "Integrations",
        Manage_Account_Email_Notifications: "Manage Account, Email Notifications",
        emoji_HR: "👩🏻‍💻  HR",
        Manage_Account_Insights: "Manage Account, Insights",
        emoji_Leader: "👩🏻‍💼 Leader",
        Insights_Medals: "Insights, Medals",
        emoji_Super_Leader: "🦸🏻‍♀️ Super Leader",
        Manage_Account_Insights_Medals: "Manage Account, Insights, Medals",
        emoji_Super_Admin: "🙆🏻‍♀️ Super Admin",
        Manage_Account_Insights_Email: "Manage Account, Insights, Email Notifications",
        Language: "Language",
        Country: "Country",
        English: "English",
        Thai: "Thai",
        BahasaMalay: "Bahasa Malay",
        ChineseHK: "Chinese (Traditional, Hong Kong)",
        BrazilianPortuguese: "Brazilian Portuguese",
        Burmese: "Burmese",
        SAVE_CHANGES: "SAVE CHANGES",
        SEND_INVITE: "SEND INVITE",
        Automatically_send_an: "Automatically send an invitation email to the new member",
        Archive_employee: "Archive employee",
        Archived_Type: "Archived Type",
        Direct_Reports: "Direct Reports",
        members_selected: "members selected",
        Re_Assign_Manager: "Re-Assign Manager",
        Search_manager_name: "Search manager name",
        Suggestions_based_on_member: "Suggestions based on member selection or search field",
        SUBMIT: "SUBMIT",
        CANCEL: "CANCEL",
        Archived_Employee: "Archived Employee",
        members_selected: "members selected",
        Edit_Team: "Edit Team",
        Edit_Manager: "Edit Manager",
        members: "members",
        Top_Most: "Top Most",
        UNARCHIVE: "UNARCHIVE",
        DELETE: "DELETE",
        delete_all: "delete all",
        Assign_Team: "Assign Team",
        Unarchive: "Unarchive",
        Delete: "Delete",
        Search_team_name: "Search team name",
        Complete_manager_assignment: ">Complete manager assignment",
        is_missing_a_direct: "is missing a direct manager. Please select a manager to secure line of management.",
        SELECT_DIRECT_MANAGER: "SELECT DIRECT MANAGER",
        Re_assign_a_manager: "Re-assign a manager to replace",
        the_archived_manager: "the archived manager",
        has_been_archived_leaving: "has been archived, leaving",
        members_without_a_direct: "members without a direct manager. Please re-assign a manager to secure line of management.",
        RE_ASSIGN_MANAGER: "RE-ASSIGN MANAGER",

        Teams: "Teams",
        powers: "powers",
        CREATE_TEAM: "CREATE TEAM",
        badges: "badges",
        Information: "Information",
        Sort_by_Direct_Reports: "Sort by Direct Reports",
        duplicate_teams: "duplicate teams",
        Sort_by_Name: "Sort by Name",
        ADD_TEAM: "ADD TEAM",
        Sort_by_Parent: "Sort by Parent",
        Team_Manager: "Team Manager",
        Parent_Team: "Parent Team",
        Team_Name: "Team Name",
        Auto_assignment: "Auto-assignment",
        Color_Tag: "Color Tag",
        A_unique_team_name: "A unique team name is required",
        A_parent_team_and: "A parent team and manager will be auto-assigned based on the team members’ relationships with managers",
        Select_a_color_tag: "Select a color tag to visually organize your teams For example, by business unit/vertical",
        No_team_members: "No team members",

        Managers: "Managers",
        Search: "Search",
        managers_selected: "managers selected",
        RE_ASSIGN_MANAGER: "RE-ASSIGN MANAGER",
        Sort_by_Direct_Reports: "Sort by Direct Reports",
        Assign_Team: "Assign Team",

        Cohorts: "Cohorts",
        CREATE: "CREATE",
        duplicate_cohorts: "duplicate cohorts",
        ADD_COHORT: "ADD COHORT",
        Cohort_Name: "Cohort Name",
        Select_Member: "Add by name, email, or team",
        Select_Leaders: "Assign leader by name (optional)",
        Auto_generated: "Auto-generated",
        Bulk_add_by_inputing: "Bulk add by inputting comma separated email addresses",
        Add_members_to_this: "Add members to this cohort",
        No_Cohort_members: "No Cohort members",
        Cohort_Leader: "Cohort Leaders",
        Leader_description: "Cohort leaders receive daily and weekly insights",
        Cohort_Type: "Cohort Type",
        Manual: "Manual",
        Dynamic: "Dynamic",
        Configure_Dynamic_Rules: "Configure Dynamic Rules",
        Dynamic_cohort_description: "Members will be automatically added or removed based on the rules you configure below.",
        Preview: "Preview",
        Please_add_at_least_one_valid_rule: "Please add at least one valid rule for dynamic cohort.",
        Error_previewing_cohort: "Error previewing cohort. Please try again.",
        No_members_match: "No members match the current rules",
    },
    pincode: {
        your_verification: "Your verification",
        enter_the_four: "Enter the 4-digit code sent to your inbox",
        your_code_is: "Your code is incorrect. Please try again…",
        you_have: "You have",
        attempts_remaining: "attempts remaining",
    },
    powerUp: {
        EXPORT: "EXPORT",
        Recognition_trends: "Recognition trends",
        PARTICIPATION_RATE: "PARTICIPATION RATE",
        No_Filter: "No Filter",
        Select_all: "Select all",
        Clear: "Clear",
        Filter_power_up : "Filter power-up activity based on recognition values",
        Cancel: "Cancel",
        Okay: "Okay",
        results_from: "results from",
        results: "results",
        Export_Power_up_Activity: "Export Power-up Activity",
        Date_Range: "Select a Start and End Date",
        Start_Date: "Start Date",
        End_Date: "End Date",
        Recipient: "Recipient(s)",
        From: "From",
        For: "For",
        Reward: "Reward",
        Sent_on: "Sent on",
        Automations: "Automations",

        Preset_Library: "Preset Library",
        By_Month: "By Month",
        Automate: "Automate",
        By_Quarter: "By Quarter",
        By_Year: "By Year",
        Create_your_own: "Create your own",
        Recognition: "Recognition",
        Power_up_Recipients: "Power-up Recipients",
        based_on_your_selection: "based on your selection",
        Preview_on_Mobile_Layout: "Preview on Mobile Layout",
        got: "got",
        for: "for",
        This_power_up_automation_has: "This power-up automation has not been activated",
        This_power_up_automation_has_been: "This power-up automation has been activated",
        Recipients: "Recipients",
        recipients: "recipients",
        Autogenerated: "Autogenerated",
        for_showing_time_period: "for showing time period",
        Add: "Add",
        Values_optional: "Values (optional)",
        Select_values_optional: "Select values (optional)",
        Schedule: "Schedule",
        Following_work_day: "Following work day",
        Time: "Time",
        Select_time: "Select time",
        Now: "Now",
        Name_of_Recipient: "Name of Recipient",
        Name_of_Recipient_s: "Name of Recipient(s)",
        Reason_for_recognition: "Reason for recognition",
        Reward_Type: "Reward Type",
        Medal_Design: "Medal Design",
        Coin_Medal_or_Gem: "Coin, Medal, or Gem",
        Amount: "Amount",
        Number_of_coins: "Number of coins",
        Number_of_gems: "Number of gems",
        Share_on_Activity_Feed: "Share on Activity Feed",
        SAVE_CHANGES: "SAVE CHANGES",
        DE_ACTIVATE_AUTOMATION: "DE-ACTIVATE AUTOMATION",
        ACTIVATE_AUTOMATION: "ACTIVATE AUTOMATION",
        SEND: "SEND",
        RESET: "RESET",

        Duplicate: "Duplicate",
        Delete: "Delete",
        Duplicate: "Duplicate",
    },
    questions: {
        add_a_question: "Add a Question",
        preview_of_daily: "Preview of Daily Insights for Managers",
        summary_of_insights: "Summary of insights from your direct reports",
        of_ten_direct: "of 10 direct reports",
        responded: "responded",
        yes: "yes",
        average_rating_out: "average rating out of 10",
        english: "English",
        thai: "Thai",
        add_option: "Add Option",
        open_ended: "Open-ended",
        yes_or_no: "Yes/No",
        multiple_choice: "Multiple Choice",
        question: "Question",
        option: "Option",
        positive: "Positive",
        neutral: "Neutral",
        negative: "Negative",
        min_label: "Min.label",
        max_label: "Max.label",
        reward: "Reward",
        power_skill: "Power Skill",
        frequency: "Frequency",
        day_of_week: "Day of Week",
        schedule: "Schedule",
        please_select_frequency: "Please select frequency",
        and_when: "and when",
        more: "more",
        assign_a_sentiment: "Assign a Sentiment",
        reward: "Reward",
        coins: "Coins",
        select_power_skill: "Select power skill (optional)",
        how_often_do: "How often do you want to ask this question?",
        what_day_of: "What day of week do you want to ask this question?",
        CALENDAR_VIEW: "Calendar View",
        Audience: "Audience",

        Active: "Active",
        Inactive: "Inactive",
        Show_All: "Show All",
        View: "View",
        Preview_of_Daily_Insights: "Preview of Daily Insights for Managers",
        Summary_of_insights_from: "Summary of insights from your direct reports",
        responded: "responded",
        of_ten_direct_reports: "of 10 direct reports",
        responded_Yes: "responded “Yes”",
        average_rating_out_of: "average rating out of 10",
        of_fifty_overal: "of 50 overall",
        English: "English",
        Thai: "Thai",
        Positive: "Positive",
        Neutral: "Neutral",
        Negative: "Negative",
        Add_Option: "Add Option",
        Min_label: "Min.label",
        Max_label: "Max.label",
        Reward: "Reward",
        Power_Skill: "Power Skill",
        Select_power_skill: "Select power skill (optional)",
        Day_of_Week: "Day of Week",
        Please_select_frequency: "Please select frequency",
        Schedule: "Schedule",
        more: "more",
        Type: "Type",
        Select_Dimension: "Select Dimension",
        Question_Format: "Question Format",
        Open_ended: "Open-ended",
        Yes_or_No: "Yes/No",
        Multiple_Choice: "Multiple Choice",
        Scale: "Scale",
        Question: "Question",
        Option: "Option",
        Frequency: "Frequency",
        Very_important: "Very important",
        Coins: "Coins",
        Power_Skill: "Power Skill",
        Select_power_skill: "Select power skill (optional)",
        Status: "Status",
        Action: "Action",
        Coins: "Coins",
        How_often__you: "How often do you want to ask this question?",
        What_day_of_week: "What day of week do you want to ask this question?",
        Not_at_all: "Not at all",
        Very_important: "Very important",
        and_when: "and when?",
        Coins: "Coins",
        QUESTION_DETAILS: "QUESTION DETAILS",
        Search: "Search",
        Assign_a_Sentiment: "Assign a Sentiment",

        Category: "Category",
        Row_Header: "Row Header",
        Row_Header_Placeholder: "A title that represents the insight from this question",
    },
    register: {
        get_started_with: "Get Started with Happily",
        set_up_one: "Set up 1 team",
        FREE: "FREE",
        BOOK_A_TIME: "BOOK A TIME",
        set_up_a: "Set up a free 21-day free trial for one team with",
        up_to_twenty: "up to 20 users",
        set_up_many: "Set up many teams",
        schedule_a_one: "Schedule a 1:1 session with our",
        team_who_will: "team who will ensure that you get",
        the_most_out: "the most out of Happily",
        Setting_up_your: "Setting up your account",
        help_us_get: "Help us get to know you and your company a bit better",
        your_name: "Your Name",
        please_input_your_name: "Please input your name",
        your_work_email: "Your work email",
        please_input_your_work: "Please input your work email",
        please_input_correct_email: "Please input correct email",
        your_phone_number: "Your phone number",
        please_input_your_phone: "Please input your phone number",
        please_input_only_number: "Please input only number",
        company_name: "Company Name",
        please_input_company: "Please input company name",
        Location: "Location",
        please_input_Location: "Please input location",
        Time_Zone: "Time Zone",
        please_input_Time_Zonen: "Please input time zone",
        language_preference: "Language Preference",
        how_many_people: "How many people",
        please_input_number_of: "Please input number of employees",
        please_input_language: "Please input language preference",
        what_would_you_like: "What would you like to achieve with Happily",
        please_input_your_achieve: "Please input your achieve",
        i_agree_to: "I agree to the",
        terms_and_conditions: "Terms & Conditions",
        verify_my_email: "Verify my email",
        confirm_your_email: "Confirm your email",
        we_sent_you: "We sent you an email verification code to ",
        the_email_may: "The email may take 15-20 seconds to get to you and will expire within the next 15 minutes",
        resend_code: "Resend Code",
        go_back: "Go back",
        book_a_meeting: "Book a Meeting",
        i_want_to: "I want to create a happier workplace.",
        Schedule_a_time_with: "Schedule a time with us",
        Setting_up_multiple_teams: "Setting up multiple teams would be easier through an import process that our team can guide you through. Book a meeting with us and we’ll get back to you (typically within the hour, up to 24 hours) to get you up and running in no time!",
    },
    reports: {
        DAILY_REPORT_PREVIEW: "DAILY REPORT PREVIEW",
        Select_a_Manager: "Select a Manager",
        Select_date: "Select date",
        Delivery_Status: "Delivery Status",
        Undelivered: "Undelivered",
        Delivered: "Delivered",
        Issue: "Issue",
        Read_Status: "Read Status",
        Preview_a_report_by: "Preview a report by selecting a manager and date",
        from_the_above_menu: "from the above menu",
        Loading: "Loading",
        Unable_to_preview_this: "Unable to preview this report due to unavailability of sufficient data",
        
        MONTHLY_REPORT_PREVIEW: "MONTHLY REPORT PREVIEW",
        Select_a_Person: "Select a Person",
        Select_month: "Select month",

        WEEKLY_REPORT_PREVIEW: "WEEKLY REPORT PREVIEW",
    },
    rewards: {
        redeemed: "Redeemed",
        add_a_reward: "Add a Reward",
        active: "Active",
        inactive: "Inactive",
        show_all: "Show All",
        status: "Status",
        coins: "Coins",
        gems: "Gems",
        edit: "Edit",
        Reward: "Reward",
        Activity: "Activity",
        preview_on_mobile: "Preview on Mobile Layout",
        REDEEM: "REDEEM",
        REQUEST: "REQUEST",
        english: "English",
        thai: "Thai",
        name: "Name",
        name_of_reward: "Name of Reward",
        mame_of_reward_Thai: "Name of Reward (Thai)",
        description: "Description",
        description_Thai: "Description (Thai)",
        cost: "Cost",
        duration: "Duration",
        start_date: "Start Date",
        end_date: "End Date",
        gift_cards: "Gift Cards",
        perks: "Perks",
        team_building: "Team Building",
        doing_good: "Doing Good",
        settings: "Settings",
        country: "Country",
        all_countries: "All Countries",
        limited_qty: "Limited Qty",
        available: "Available",
        no_limit: "No limit",
        Require_Approval: "Require Approval",
        On: "On",
        Off: "Off",
        image: "Image",
        upload: "Upload",
        file_size_should: "File size should be 600 x 320 px. Reward thumbnail auto-generated to center square.",
        reward: "Reward",
        processing: "Processing",
        sent: "Sent",
        cancel: "Cancel",
        confirm_cancellation: "Confirm Cancellation",
        are_you_sure: "Are you sure you want to cancel the",
        redeemed_by: "redeemed by (Gifted to)",
        Recipient: "Recipient",
        Value: "Value",
        Type: "Type",
        Date_and_Time: "Date and Time",
        Delivered: "Delivered",
        no: "No",
        yes_and_refund: "Yes & Refund",
        yes_and_do: "Yes & Do Not Refund",
        refund: "Cancel & Refund",
    },
    sparks: {
        custom_sparks: "custom sparks",
        Create_a_Set: "Create a Set",
        Set: "Set",
        HAPPILY_S_SPARKS: "HAPPILY’S SPARKS",
        Name_of_Spark_Set: "Name of Spark Set",
        Please_input_Set_Name: "Please input Set Name",
        Display_After: "Display After",
        Before_Set_one: "Before Set 1",
        Audience: "Audience",
        Set_name: "Set name",
        Select: "Select",
        SAVE_CHANGES: "SAVE CHANGES",
        CANCEL: "CANCEL",
        DELETE_SPARK_SET: "DELETE SPARK SET",
        CREATE_SET: "CREATE SET",
        Title: "Title",
        Edit: "Edit",
        Set: "Set",
        Draft: "Draft",
        Create_a_New_Card: "Create a New Card",
        Spark_Title: "Spark Title",
        Please_input_Spark_Title: "Please input Spark Title",
        Spark_Icon: "Spark Icon",
        Spark_Content_English: "Spark Content - English",
        Spark_Content_Thai: "Spark Content - Thai",
        SAVE_SPARK: "SAVE SPARK",
        CANCEL: "CANCEL",
        DELETE: "DELETE",
    },
    demomode: {
        demo_on: "Demo Mode On",
        demo_tooltip: "Usernames and team names will be censored. Go to Settings for more information.",
        detected_title: "We detected that you had left demo mode on since your last login.",
        detected_sub: "Don't worry, we'll keep it on between page refreshes.",
        warning: "WARNING: NAMES AND DETAILS SHOWN IN THE REPORT WILL NOT BE CENSORED",
    },
    sso: {
        your: "Your",
        this_account: "This account",
        has_been_set: "has been set up to use single sign-on",
        google_sign_In: "Google Sign-In",
        sign_In: "Sign-In",
        sign_Out: "Sign-Out",
    }
}